const MAX_CHUNK_SIZE = 3500;

export class CookieStorage {
  private domain: string;

  constructor(domain: string) {
    this.domain = domain;
  }

  getItem(key: string): string | null {
    const chunks: string[] = [];
    let i = 0;
    while (true) {
      const value = this.readCookie(this.chunkName(key, i));
      if (value === null) break;
      chunks.push(value);
      i++;
    }
    return chunks.length > 0 ? chunks.join('') : null;
  }

  setItem(key: string, value: string): void {
    this.removeItem(key);
    for (let i = 0; i * MAX_CHUNK_SIZE < value.length; i++) {
      const chunk = value.slice(i * MAX_CHUNK_SIZE, (i + 1) * MAX_CHUNK_SIZE);
      this.writeCookie(this.chunkName(key, i), chunk);
    }
  }

  removeItem(key: string): void {
    let i = 0;
    while (true) {
      const name = this.chunkName(key, i);
      if (this.readCookie(name) === null) break;
      this.deleteCookie(name);
      i++;
    }
  }

  private chunkName(key: string, index: number): string {
    const safe = key.replace(/[^a-zA-Z0-9_-]/g, '_');
    return `otto_${safe}_${index}`;
  }

  private readCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  }

  private writeCookie(name: string, value: string): void {
    const parts = [
      `${name}=${encodeURIComponent(value)}`,
      'path=/',
      `max-age=${60 * 60 * 24 * 30}`,
      'samesite=lax',
    ];
    if (this.domain) parts.push(`domain=${this.domain}`);
    if (location.protocol === 'https:') parts.push('secure');
    document.cookie = parts.join('; ');
  }

  private deleteCookie(name: string): void {
    const parts = [`${name}=`, 'path=/', 'max-age=0'];
    if (this.domain) parts.push(`domain=${this.domain}`);
    document.cookie = parts.join('; ');
  }
}
